import { render, staticRenderFns } from "./RechercheEtudiant.vue?vue&type=template&id=2ad771ed"
import script from "./RechercheEtudiant.vue?vue&type=script&lang=js"
export * from "./RechercheEtudiant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports